@let day = registrationDay();
<div class="registration-container">
    <div class="my-3">
        <div class="d-flex justify-content-between">
            <h4 class="first-letter-capital">
                <strong>{{day.date | date:'EEEE d MMMM yyyy'}}</strong>
            </h4>
            <div class="d-flex justify-content-between align-items-center gap-1">
                @if ((Roles.Management | hasRole)) {
                    <button (click)="approveDateRegistrations(day.users)" class="btn btn-secondary px-1 py-1 ms-1 d-print-none" type="button">
                        <i class="material-icons fs-4">add_task</i>
                    </button>
                }
                <strong class="total-hour-width">
                    @if (showUser()) {
                        {{day.users[0].totalMinutes | minutes}}
                    }
                </strong>
            </div>
        </div>
        @for (user of day.users; track user.userId) {
            @if (!showUser()) {
                <div class="d-flex justify-content-between mt-2">
                    <strong>
                        {{user.name}}
                    </strong>
                    <strong>{{user.totalMinutes | minutes}}</strong>
                </div>
            }
            @for (registration of user.registrations; track registration.id) {
                <div
                    (contextmenu)="contextMenuFn()?.(registration, $event)"
                    [class.hour-approved]="registration.approved_at && registration.approved_by"
                    [class.hour-disapproved]="registration.disapproved_at && registration.approved_by"
                    [class.ms-3]="!showUser()">
                    <strong [class.light]="registration.lightStart">
                        {{registration.starttime | date:'HH:mm':'UTC'}}
                    </strong>
                    -
                    <strong [class.light]="registration.lightEnd">
                        {{registration.endtime | date:'HH:mm':'UTC'}}
                    </strong>
                    -
                    @if (!showCompany()) {
                        {{companies() | companyName:registration.company_id}} &raquo;
                    }
                    @if (registration.project.name) {
                        {{registration.project.name}} &raquo;
                    }
                    {{registration.name}}
                </div>
                @for (comment of registration.comments; track comment.id) {
                    <div
                        [class.comment-spacing-big]="!showUser()"
                        [class.comment-spacing-small]="showUser()"
                        class="text-muted"
                        style="font-size: 13px; line-height: 1.6">
                        {{comment.datetime | date:'HH:mm':'UTC'}} {{comment.description}}
                    </div>
                }
            }
        }
    </div>
    <hr class="striped-spacing">
</div>
